import { motion } from 'motion/react';
import { chatItemFade } from '@reflex/plugin-api/motion';

interface AnimatedChatItemProps {
  children: React.ReactNode;
  className?: string;
  /**
   * Scroll anchor for this row. Set on turn-starting rows so the turn rail can
   * find and scroll to them; the wrapper is also made focusable so a jump moves
   * keyboard focus with the viewport.
   */
  id?: string;
}

/**
 * Subtle slide-up + fade entrance for chat items.
 * Wrap each message, turn, or banner in this to avoid jarring pops.
 *
 * Rows need no size declaration here: the transcript pins each row's
 * `contain-intrinsic-size` to its measured height (`use-measured-row-sizes.ts`)
 * so `content-visibility` skipping never changes layout.
 */
export function AnimatedChatItem({ children, className, id }: AnimatedChatItemProps) {
  return (
    <motion.div {...chatItemFade} id={id} tabIndex={id ? -1 : undefined} className={className}>
      {children}
    </motion.div>
  );
}
